export * from './alert.component';




// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/_directives/index.ts